import styled, {css} from "styled-components";

interface IProgressTextDefaultBoxProps {
    bigSize: boolean;
    verticalMode?: boolean;
}

export const ProgressTextDefaultBox = styled.div<IProgressTextDefaultBoxProps>`
    font-size: ${props => props.bigSize ? "0" : "1.4"}rem;
    line-height: 1.1;
    transition: all 0.4s ease-in;
    width: ${props => props.bigSize ? "0rem" : (props.verticalMode ? "auto" : "7rem")};
    padding: ${props => props.bigSize ? "0rem" : (props.verticalMode ? "0" : "0 0.8rem")}; // 1rem 0px 1.2rem
    ${props => props.verticalMode ? css`
        height: ${props.bigSize ? "0" : "2.4rem"};
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center;
        margin-bottom: ${props.bigSize ? "0" : "0.7rem"};
    ` : null}
    @media ${props => props.theme.mediaQuery.lAndBelow} {
        font-size: ${props => props.bigSize ? "0" : "1"}rem;
        width: ${props => props.bigSize ? "0rem" : (props.verticalMode ? "auto" : "4rem")};
        padding: ${props => props.bigSize ? "0rem" : (props.verticalMode ? "0" : "0.5rem 0")}; // 0.7rem 0px 1.2rem
        margin-top: ${props => props.verticalMode ? "0" : "-1px"};
    }
    opacity: ${props => props.bigSize ? "0" : "1"};
    color: ${props => props.theme.colors.brandSecondary};
`;